<!--Copy right - © 2024 tecera gmbh-->
<script>
    export let label;
    export let value;
</script>


<div class="row" >
    <div class="col-6">{label}</div>
    <div class="col-6" style="word-break:break-all;" >{value==null ? "" : value}</div>
</div>